export const actions = {
  FRUTAS_LOAD_REQUESTED: 'FRUTAS_LOAD_REQUESTED',
  FRUTAS_LOAD_SUCCEEDED: 'FRUTAS_LOAD_SUCCEEDED',
  FRUTAS_LOAD_FILED: 'FRUTAS_LOAD_FILED',

  FRUTA_UPDATE_REQUESTED: 'FRUTA_UPDATE_REQUESTED',
  FRUTA_UPDATE_SUCCEEDED: 'FRUTA_UPDATE_SUCCEEDED',
  FRUTA_UPDATE_FILED: 'FRUTA_UPDATE_FILED',

  FRUTA_INSERT_REQUESTED: 'FRUTA_INSERT_REQUESTED',
  FRUTA_INSERT_SUCCEEDED: 'FRUTA_INSERT_SUCCEEDED',
  FRUTA_INSERT_FILED: 'FRUTA_INSERT_FILED',

  FRUTA_DELETE_REQUESTED: 'FRUTA_DELETE_REQUESTED',
  FRUTA_DELETE_SUCCEEDED: 'FRUTA_DELETE_SUCCEEDED',
  FRUTA_DELETE_FILED: 'FRUTA_DELETE_FILED',
}

export const getFrutasAction = dispatch => {
  dispatch({
    type: actions.FRUTAS_LOAD_REQUESTED,
  })
}

export const onSubmitInsertFrutaFormAction = (dispatch, formFruta) => {
  dispatch({
    type: actions.FRUTA_INSERT_REQUESTED,
    payload: formFruta,
  })
}

export const onSubmitUpdateFrutaFormAction = (dispatch, formFruta) => {
  dispatch({
    type: actions.FRUTA_UPDATE_REQUESTED,
    payload: formFruta,
  })
}

export const deleteFrutaAction = (dispatch, id) => {
  dispatch({
    type: actions.FRUTA_DELETE_REQUESTED,
    payload: id,
  })
}
